(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('backdoor', {
            parent: 'account',
            url: '/backdoor',
            data: {
                authorities: [],
                pageTitle: 'Backdoor'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/backdoor/backdoor.html',
                    controller: 'BackdoorController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
